<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :btnEditVisible="false" :linkedit="linkedit" :data="data" :showModalLoading="showModalLoading" :pathResource="pathResource">
        <!-- <template slot="btn-left"> </template> -->
        <template slot="table-filter">
            <b-row>
                <b-col cols="12" sm="2" class="sa-text-right">Tipo:</b-col>
                <b-col cols="12" sm="4" class="sa-text-left">
                    <span class="sa-text-data">{{ data.tipoReferto }}</span>
                </b-col>
                <b-col cols="12" sm="2" class="sa-text-right">Data:</b-col>
                <b-col cols="12" sm="4" class="sa-text-left">
                    <span class="sa-text-data">{{ formatDate(data.dataOra) }}</span>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <b-embed type="iframe" :src="referto" allowfullscreen></b-embed>
        </template>
        <template slot="footer"> </template>
    </sa-page-layout>
</template>
<script>
import axios from "axios";
import moment from "moment";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
export default {
    components: { SaPageLayout },

    data() {
        return {
            task: { nome: "" },
            showModalLoading: false,
            linkback: "/sorveglianzareferti",
            linkedit: null,
            elaborazione: false,
            currentPage: 1,
            totalRows: 1,
            perPage: 100,
            filter: "",
            pathResource: "/sorveglianzareferti",
            items: [],
            data: {},
            ricevente: { id: "-1", idInvioSms: null },
            fileCsv: { primaRigaIntestazione: true, file: null },
            stato: { log: "" },
            filtro: {},
            referto: null,
        };
    },
    created: function () {},
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    update: function () {
        console.log("Update");
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment(new Date(value)).format("DD-MM-YYYY HH:mm:ss");
            } else {
                return "---";
            }
        },
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
            axios.get(link + me.id).then((response) => {
                me.data = response.data.data;
                me.referto = me.data.referto.includes("data:application/pdf;base64,") ? me.data.referto : "data:application/pdf;base64," + me.data.referto;

                me.showModalLoading = false;
            });
        },

        onRefreshDettatio() {
            let me = this;
            me.loadDataDetails();
        },
    },
};
</script>
